var map = {
	"./ACU/ACU.configuration.json": [
		48919,
		408
	],
	"./Adelaide/Adelaide.configuration.json": [
		19027,
		7160
	],
	"./Bath/Bath.configuration.json": [
		68935,
		4992
	],
	"./Bolton/Bolton.configuration.json": [
		13661,
		5005
	],
	"./Bournemouth/Bournemouth.configuration.json": [
		84823,
		1929
	],
	"./CQU/CQU.configuration.json": [
		96791,
		3516
	],
	"./City/City.configuration.json": [
		3351,
		2758
	],
	"./Conestoga/Conestoga.configuration.json": [
		57023,
		7266
	],
	"./Deakin/Deakin.configuration.json": [
		54701,
		8955
	],
	"./Derby/Derby.configuration.json": [
		82655,
		4871
	],
	"./ECU/ECU.configuration.json": [
		21111,
		2028
	],
	"./Flinders/Flinders.configuration.json": [
		46611,
		8340
	],
	"./GU/GU.configuration.json": [
		36401,
		3179
	],
	"./Greenwich/Greenwich.configuration.json": [
		79295,
		3665
	],
	"./JCU/JCU.configuration.json": [
		70423,
		2999
	],
	"./Kingston/Kingston.configuration.json": [
		23371,
		3972
	],
	"./LSE/LSE.configuration.json": [
		95015,
		7749
	],
	"./LaTrobe/LaTrobe.configuration.json": [
		55255,
		9020
	],
	"./MMU/MMU.configuration.json": [
		83087,
		7034
	],
	"./MQ/MQ.configuration.json": [
		31549,
		7953
	],
	"./MacEwan/MacEwan.configuration.json": [
		1547,
		5141
	],
	"./Melbourne/Melbourne.configuration.json": [
		82623,
		6692
	],
	"./Monash/Monash.configuration.json": [
		69393,
		3193
	],
	"./Murdoch/Murdoch.configuration.json": [
		42247,
		8651
	],
	"./ND/ND.configuration.json": [
		82549,
		7117
	],
	"./NTU/NTU.configuration.json": [
		15339,
		5882
	],
	"./Nanyang/Nanyang.configuration.json": [
		93483,
		6285
	],
	"./Newcastle/Newcastle.configuration.json": [
		56459,
		2103
	],
	"./Nottingham/Nottingham.configuration.json": [
		52659,
		4748
	],
	"./Otago/Otago.configuration.json": [
		60903,
		8857
	],
	"./Purdue/Purdue.configuration.json": [
		36623,
		6346
	],
	"./QUT/QUT.configuration.json": [
		56347,
		9319
	],
	"./RMIT/RMIT.configuration.json": [
		18177,
		1423
	],
	"./Regents/Regents.configuration.json": [
		2871,
		113
	],
	"./SCU/SCU.configuration.json": [
		80463,
		710
	],
	"./SHU/SHU.configuration.json": [
		92755,
		851
	],
	"./Salford/Salford.configuration.json": [
		71183,
		446
	],
	"./Sussex/Sussex.configuration.json": [
		1623,
		2474
	],
	"./Swin/Swin.configuration.json": [
		44551,
		8956
	],
	"./Sydney/Sydney.configuration.json": [
		4857,
		6947
	],
	"./UC/UC.configuration.json": [
		8349,
		4411
	],
	"./UCLAN/UCLAN.configuration.json": [
		65207,
		7604
	],
	"./UCT/UCT.configuration.json": [
		19239,
		309
	],
	"./ULaw/ULaw.configuration.json": [
		18959,
		4504
	],
	"./UOW/UOW.configuration.json": [
		51103,
		7514
	],
	"./UP/UP.configuration.json": [
		67331,
		2960
	],
	"./UQ/UQ.configuration.json": [
		49261,
		5769
	],
	"./USC/USC.configuration.json": [
		75319,
		2170
	],
	"./USQ/USQ.configuration.json": [
		47447,
		5112
	],
	"./UTM/UTM.configuration.json": [
		43943,
		6473
	],
	"./UTP/UTP.configuration.json": [
		60007,
		5948
	],
	"./UTS/UTS.configuration.json": [
		37171,
		5959
	],
	"./UWA/UWA.configuration.json": [
		92871,
		6276
	],
	"./UWS/UWS.configuration.json": [
		42687,
		4758
	],
	"./UniSA/UniSA.configuration.json": [
		22891,
		6151
	],
	"./VU/VU.configuration.json": [
		60415,
		8332
	],
	"./abdn/abdn.configuration.json": [
		60947,
		2292
	],
	"./angliss/angliss.configuration.json": [
		27343,
		8990
	],
	"./bpp/bpp.configuration.json": [
		86699,
		3255
	],
	"./cardiffmet/cardiffmet.configuration.json": [
		44851,
		8096
	],
	"./chester/chester.configuration.json": [
		73484,
		5539
	],
	"./conestogatest/conestogatest.configuration.json": [
		26931,
		8218
	],
	"./demo/demo.configuration.json": [
		7015,
		2594
	],
	"./demous/demous.configuration.json": [
		92375,
		6074
	],
	"./ed/ed.configuration.json": [
		66211,
		9716
	],
	"./essex/essex.configuration.json": [
		64931,
		9793
	],
	"./future/future.configuration.json": [
		55287,
		5282
	],
	"./gcu/gcu.configuration.json": [
		87391,
		4314
	],
	"./glos/glos.configuration.json": [
		33655,
		4848
	],
	"./gordon/gordon.configuration.json": [
		88183,
		6552
	],
	"./icon/icon.configuration.json": [
		98815,
		6480
	],
	"./keele/keele.configuration.json": [
		16411,
		3473
	],
	"./leedsmet/leedsmet.configuration.json": [
		29687,
		4650
	],
	"./local/local.configuration.json": [
		38495,
		1176
	],
	"./lsbu/lsbu.configuration.json": [
		67305,
		5395
	],
	"./napier/napier.configuration.json": [
		97491,
		8027
	],
	"./nottinghammalaysia/nottinghammalaysia.configuration.json": [
		49825,
		6205
	],
	"./open/open.configuration.json": [
		39929,
		7723
	],
	"./pentest/pentest.configuration.json": [
		93492,
		9628
	],
	"./qmu/qmu.configuration.json": [
		21311,
		4678
	],
	"./rcsi/rcsi.configuration.json": [
		78039,
		5914
	],
	"./staging/staging.configuration.json": [
		76951,
		9794
	],
	"./staging5v11/staging5v11.configuration.json": [
		40995,
		7373
	],
	"./staging5v12/staging5v12.configuration.json": [
		62535,
		6374
	],
	"./staging5v13/staging5v13.configuration.json": [
		64723,
		767
	],
	"./staging5v14/staging5v14.configuration.json": [
		13020,
		1744
	],
	"./staging5v15/staging5v15.configuration.json": [
		11395,
		4553
	],
	"./staging5v16/staging5v16.configuration.json": [
		44415,
		7362
	],
	"./staging5v16codefreeze/staging5v16codefreeze.configuration.json": [
		58295,
		468
	],
	"./staging5v16regression/staging5v16regression.configuration.json": [
		59675,
		3765
	],
	"./stagingQUT/stagingQUT.configuration.json": [
		89875,
		4900
	],
	"./strath/strath.configuration.json": [
		1421,
		6853
	],
	"./uea/uea.configuration.json": [
		73031,
		8318
	],
	"./ufs/ufs.configuration.json": [
		97563,
		729
	],
	"./uk/uk.configuration.json": [
		73021,
		3251
	],
	"./unihubuk/unihubuk.configuration.json": [
		29975,
		6484
	],
	"./uregina/uregina.configuration.json": [
		69127,
		1124
	],
	"./utsc/utsc.configuration.json": [
		80599,
		4958
	],
	"./uwe/uwe.configuration.json": [
		91479,
		9040
	],
	"./warwick/warwick.configuration.json": [
		34563,
		4985
	],
	"./wmin/wmin.configuration.json": [
		2391,
		150
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19351;
module.exports = webpackAsyncContext;